export default __webpack_public_path__ + "static/media/plato-logo.491f089b.svg";